import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { USAEPayAchPageRoutingModule } from './usaepay-ach-routing.module';

import { USAEPayAchPage } from './usaepay-ach.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { AddressDetailsPageModule } from '../../../../address-details/address-details.module';
import { CustomInputModule } from 'src/app/master/common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    USAEPayAchPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    AddressDetailsPageModule,
    CustomInputModule,
  ],
  declarations: [USAEPayAchPage],
})
export class USAEPayAchPageModule {}
